import * as React from "react"
import { cn } from "../../lib/utils"
import { inputVariants } from "./input"
import type { VariantProps } from "class-variance-authority"

export interface SelectProps
  extends React.SelectHTMLAttributes<HTMLSelectElement>,
    VariantProps<typeof inputVariants> {}

const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, variant, ...props }, ref) => (
    <select ref={ref} className={cn(inputVariants({ variant }), "appearance-none cursor-pointer", className)} {...props} />
  )
)
Select.displayName = "Select"

export { Select }
